import React, { useState, useEffect, useRef } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import CustomerServicesManagements from "./customer_services_management";
import TransactionHistoryManagement from "./transaction_history_management";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import moment from "moment";
import { Calendar } from "primereact/calendar";
import { OverlayPanel } from "primereact/overlaypanel";

export default function MainCustomerService({}) {
  const menuRef = useRef(null);
  const exportCSVRef = useRef(() => {});

  const [globalFilter, setGlobalFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [tempStatus, setTempStatus] = useState("");
  const [rowselect, setRowselect] = useState(null);
  const [editable, setEditable] = useState();
  const [selectedData, setSelectedData] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [fromDate, setFromDate] = useState(moment().startOf("month").toDate());
  const [toDate, setToDate] = useState(moment().endOf("month").toDate());

  const toggleDialogMode = (editMode = false, rowData = null) => {
    setShowDialog(true);
    setIsEdit(editMode);
    setRowselect(rowData);
    if (!editMode) {
      setSelectedData(null);
    }
  };

  const handleApplyFilter = () => {
    setStatusFilter(tempStatus);
    if (menuRef.current) {
      menuRef.current.hide();
    }
  };

  const handleResetFilter = (e) => {
    setStatusFilter("");
    setTempStatus("");
  };

  const resetFilters = () => {
    setGlobalFilter("");
    setFromDate(moment().startOf("month").toDate());
    setToDate(moment().endOf("month").toDate());
  };

  return (
    <>
      <div className="grid align-items-center mb-3 p-2 justify-content-between gap-3">
        <div>
          <span className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText
              className="mbl_view"
              placeholder="Search"
              value={globalFilter}
              onChange={(e) => setGlobalFilter(e.target.value)}
            />
          </span>
        </div>
        <div className="grid gap-3">
          <Calendar
            placeholder="Select From Date"
            showIcon
            value={fromDate}
            onChange={(e) => setFromDate(e.value)}
            maxDate={toDate}
          />
          <Calendar
            placeholder="Select To Date"
            showIcon
            value={toDate}
            onChange={(e) => setToDate(e.value)}
            minDate={fromDate}
          />
          {activeTab === 0 && (
            <>
              <OverlayPanel ref={menuRef} className="filter-menu">
                <div className="p-field p-fluid mt-3">
                  <Dropdown
                    value={tempStatus}
                    options={[
                      { label: "Failed", value: "Failed" },
                      { label: "Completed", value: "Completed" },
                    ]}
                    onChange={(e) => {
                      e.originalEvent.stopPropagation();
                      setTempStatus(e.value || "");
                    }}
                    placeholder="Select Status"
                    showClear={!!tempStatus}
                    filter
                  />
                </div>

                <div
                  className="p-field p-fluid mt-4"
                  style={{ display: "flex", gap: "10px", whiteSpace: "nowrap" }}
                >
                  <Button
                    label="Reset"
                    className="p-button-secondary"
                    onClick={handleResetFilter}
                  />
                  <Button
                    label="Apply"
                    className="p-button-primary"
                    onClick={handleApplyFilter}
                  />
                </div>
              </OverlayPanel>

              <Button
                label="Filters"
                icon="pi pi-filter"
                className="p-button filters-btn"
                onClick={(e) => menuRef.current.toggle(e)}
              />
            </>
          )}
          <Button
            className="custom-btn export-excel secondary-button"
            label="Export Excel"
            icon="pi pi-window-maximize"
            onClick={() => exportCSVRef.current()}
          />
          {activeTab === 1 && (
            <Button
              label="Add New"
              icon="pi pi-plus"
              onClick={() => {
                setEditable(false);
                toggleDialogMode(false);
              }}
              className="p-button"
            />
          )}
        </div>
      </div>

      <TabView
        activeIndex={activeTab}
        onTabChange={(e) => {
          setActiveTab(e.index);
          resetFilters();
        }}
      >
        <TabPanel header="Transaction History ">
          <TransactionHistoryManagement
            globalFilter={globalFilter}
            exportCSV={exportCSVRef}
            statusFilter={statusFilter}
            fromDate={fromDate}
            toDate={toDate}
          />
        </TabPanel>
        <TabPanel header="Customer Requests ">
          <CustomerServicesManagements
            showDialog={showDialog}
            setShowDialog={setShowDialog}
            isEdit={isEdit}
            selectedData={selectedData}
            exportCSV={exportCSVRef}
            globalFilter={globalFilter}
            statusFilter={statusFilter}
            fromDate={fromDate}
            toDate={toDate}
          />
        </TabPanel>
      </TabView>
    </>
  );
}
